import React, { useState, useEffect } from "react";
import axios from "axios";
import Image from "next/image";
import { useRouter } from "next/router";

function Login() {
    const router = useRouter();
    const { redirect } = router.query;
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Check if already authenticated
        const checkAuth = async () => {
            try {
                const response = await axios.get('/api/auth/check', { 
                    withCredentials: true 
                });
                if (response.data.authenticated) {
                    router.push(redirect || '/querty/blog');
                }
            } catch (error) {
                // Not authenticated, stay on login page
                console.log('Not authenticated');
            }
        };
        checkAuth();
    }, [redirect, router]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError("");

        if (!email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)) {
            setError("Please enter a valid email address.");
            setLoading(false);
            return;
        }

        try {
            const response = await axios.post("/api/querty/login", {
                email,
                password,
            }, {
                withCredentials: true,
            });

            if (response.data.message === "Login successful") {
                // Small delay to ensure cookie is set
                setTimeout(() => {
                    router.push(redirect || "/querty/blog");
                }, 100);
            }
        } catch (err) {
            setError(err.response?.data?.message || "Invalid email or password. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-900">
            <div className="w-full mx-auto max-w-md p-1">
                <div className="text-center mb-6 flex justify-center items-center">
                    <Image 
                        src="https://d30aze0b97iznc.cloudfront.net/logo-white.svg" 
                        alt="Logo" 
                        width={50} 
                        height={50} 
                        className="w-32 h-32" 
                    />
                </div>
                <div className="w-full bg-gray-800 p-8 rounded-lg shadow-md">
                    <h2 className="text-2xl font-bold text-center mb-6 text-white">Login</h2>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-300">
                                Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                disabled={loading}
                                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            />
                        </div>
                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-300">
                                Password
                            </label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                disabled={loading}
                                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            />
                        </div>
                        {error && <p className="text-red-500 text-sm">{error}</p>}
                        <div>
                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                                {loading ? "Loading..." : "Login"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;